import config from 'constants/config'

export const MAPBOX_ACCESS_TOKEN_USE_CASES = {
  default: 'default',
  accommodationSearch: 'accommodationSearch',
  cruises: 'cruises',
  experiences: 'experiences',
  flashHotel: 'flashHotel',
  property: 'property',
  tripPlanner: 'tripPlanner',
} as const

export type MapboxAccessTokenUseCase = typeof MAPBOX_ACCESS_TOKEN_USE_CASES[keyof typeof MAPBOX_ACCESS_TOKEN_USE_CASES]

type MapboxAccessTokenConfigKey =
  | 'MAP_BOX_ACCOMMODATION_SEARCH_API_KEY'
  | 'MAP_BOX_CRUISES_API_KEY'
  | 'MAP_BOX_EXPERIENCES_API_KEY'
  | 'MAP_BOX_FLASH_API_KEY'
  | 'MAP_BOX_PROPERTY_API_KEY'
  | 'MAP_BOX_TRIP_PLANNER_API_KEY'

const MAPBOX_PRODUCTION_ACCESS_TOKEN_CONFIG_KEY_BY_USE_CASE: Partial<Record<MapboxAccessTokenUseCase, MapboxAccessTokenConfigKey>> = {
  [MAPBOX_ACCESS_TOKEN_USE_CASES.accommodationSearch]: 'MAP_BOX_ACCOMMODATION_SEARCH_API_KEY',
  [MAPBOX_ACCESS_TOKEN_USE_CASES.cruises]: 'MAP_BOX_CRUISES_API_KEY',
  [MAPBOX_ACCESS_TOKEN_USE_CASES.experiences]: 'MAP_BOX_EXPERIENCES_API_KEY',
  [MAPBOX_ACCESS_TOKEN_USE_CASES.flashHotel]: 'MAP_BOX_FLASH_API_KEY',
  [MAPBOX_ACCESS_TOKEN_USE_CASES.property]: 'MAP_BOX_PROPERTY_API_KEY',
  [MAPBOX_ACCESS_TOKEN_USE_CASES.tripPlanner]: 'MAP_BOX_TRIP_PLANNER_API_KEY',
}

function getConfiguredAccessToken(appConfig: App.AppConfig, configKey: MapboxAccessTokenConfigKey | 'MAP_BOX_API_KEY'): string | undefined {
  const accessToken = appConfig[configKey]
  return typeof accessToken === 'string' && accessToken.length > 0 ? accessToken : undefined
}

export function getMapboxAccessToken(
  useCase: MapboxAccessTokenUseCase = MAPBOX_ACCESS_TOKEN_USE_CASES.default,
  appConfig: App.AppConfig = config,
): string | undefined {
  const defaultAccessToken = getConfiguredAccessToken(appConfig, 'MAP_BOX_API_KEY')

  if (appConfig.APP_ENV !== 'production') {
    return defaultAccessToken
  }

  const productionConfigKey = MAPBOX_PRODUCTION_ACCESS_TOKEN_CONFIG_KEY_BY_USE_CASE[useCase]
  if (!productionConfigKey) {
    return defaultAccessToken
  }

  return getConfiguredAccessToken(appConfig, productionConfigKey) ?? defaultAccessToken
}
